import { cn } from "@/lib/utils";

export type ProgressTone = "success" | "warning" | "danger" | "info" | "pending";

const TONES: Record<ProgressTone, string> = {
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-danger",
  info: "bg-info",
  pending: "bg-pending",
};

export function Progress({
  value,
  tone = "info",
  size = "md",
  label,
  showLabel = true,
  className,
}: {
  value: number;
  tone?: ProgressTone;
  size?: "sm" | "md";
  label?: string;
  showLabel?: boolean;
  className?: string;
}) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={cn("w-full", className)}>
      {showLabel && (
        <div className="mb-1 flex items-center justify-between gap-2 text-xs">
          {label && <span className="font-semibold text-ink">{label}</span>}
          <span className="text-muted">{pct}%</span>
        </div>
      )}
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? "Progress"}
        className={cn("w-full overflow-hidden rounded-full bg-disabled-soft", size === "sm" ? "h-1.5" : "h-2.5")}
      >
        <div
          className={cn("h-full rounded-full transition-[width] duration-300", TONES[tone])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}